import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import logo from "../assets/img/logo.png";
import phone from "../assets/img/phone.png";
import email from "../assets/img/email.png";
import facebook from "../assets/img/facebook.png";
import twitter from "../assets/img/twitter.png";
import linkedin from "../assets/img/linkedin.png";
import instagram from "../assets/img/instagram.png";
import serach from "../assets/search.png";
import HeroSection from "../components/utility/HeroSection";

const navigation = [
  { name: "HOME", to: "https://supersprings.co.in/" },
  { name: "ABOUT US", to: "https://supersprings.co.in/index.php/about-us/" },
  { name: "PRODUCTS", to: "https://supersprings.co.in/index.php/products/" },
  { name: "QUALITY CERTIFICATION", to: "https://supersprings.co.in/index.php/quality-certification/" },
  { name: "STANDARD ROOM", to: "https://supersprings.co.in/index.php/quality/" },
  { name: "CUSTOMER LIST", to: "https://supersprings.co.in/index.php/customer-list/" },
  { name: "CONTACT US", to: "https://supersprings.co.in/index.php/contact-us/" },
];

const topNavLinks = [
  { name: "Home", to: "https://supersprings.co.in/" },
  { name: "About", to: "#" },
  { name: "Quality Assurance", to: "#" },
  { name: "Contact", to: "https://supersprings.co.in/index.php/contact-us/" },
];

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Top Navbar */}
      <div className="bg-black text-sm text-white py-2 px-4 lg:px-7">
        <div className="max-w-7xl mx-auto flex gap-2 flex-wrap justify-between items-center">
          {/* Left side: phone and email */}
          <div className="flex gap-8 items-center">
            <a
              href="tel:+911204337718"
              className="text-[1rem] hover:underline flex gap-3 items-center md:text-[0.7rem]"
            >
              <img
                src={phone}
                alt=""
                style={{
                  width: "25px",
                  height: "24px",
                  background: "white",
                  padding: "2px 6px",
                  borderRadius: "2px",
                }}
              />
              +91-1204337718
            </a>
            <a
              href="mailto:info@supersprings.co.in"
              className="text-[1rem] hover:underline flex gap-3 items-center md:text-[0.7rem]"
            >
              <img
                src={email}
                alt=""
                style={{
                  width: "25px",
                  height: "24px",
                  background: "white",
                  padding: "3px 6px",
                  borderRadius: "2px",
                }}
              />
              info@supersprings.co.in
            </a>
          </div>

          {/* Right side: social icons */}
          <div className="flex gap-3 items-center">
            <a
              href="#"
              className="hover:underline text-lg flex gap-3 items-center"
            >
            <img
              src={facebook}
              alt=""
              style={{
                width: "2.3rem",
                padding: "2px 6px",
                borderRadius: "2px",
              }}
            /></a>
            <a
              href="#"
              className="hover:underline text-lg flex gap-3 items-center"
            >
            <img
              src={twitter}
              alt=""
              style={{
                width: "2.3rem",
                padding: "2px 6px",
                borderRadius: "2px",
              }}
            /></a>
            <a
              href="#"
              className="hover:underline text-lg flex gap-3 items-center"
            >
            <img
              src={linkedin}
              alt=""
              style={{
                width: "2.3rem",
                padding: "2px 6px",
                borderRadius: "2px",
              }}
            /></a>
            <a
              href="#"
              className="hover:underline text-lg flex gap-3 items-center"
            >
            <img
              src={instagram}
              alt=""
              style={{
                width: "2.3rem",
                padding: "2px 6px",
                borderRadius: "2px",
              }}
            />
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <header className="bg-white shadow-sm" >
        <nav
          aria-label="Global"
          className="flex items-center justify-between p-2 lg:px-8"
        >
          <div className="flex lg:flex-1 gap-4">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                alt="Logo"
                src={logo}
                style={{ width: "330px", height: "auto" }}
              />
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-[3px] text-gray-700 border border-orange-400">
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="size-6 text-[#ff5e13] w-[45px] rounded " />
            </button>
          </div>
          <div className="flex lg:hidden pr-10">
            <a href="https://supersprings.co.in/">
              <img src={serach} alt="" style={{width: '1.4rem'}}/>
            </a>
          </div>

          <div className="hidden lg:flex lg:gap-x-5 items-center">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.to}
                className="text-[14px] font-[500] text-[#273272] hover:text-[#FE0467]"
              >
                {item.name}
              </Link>
            ))}

            <a href="https://supersprings.co.in/">
            <img src={serach} alt="" style={{width: '1.7rem'}}/>
            </a>
          </div>
        </nav>

        {/* Mobile Menu */}
        <Dialog
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
          className="lg:hidden"
        >
          <div className="fixed inset-0 z-50 bg-black bg-opacity-25" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full bg-white px-[0.4rem] py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10" style={{backgroundColor: '#f7f7f7'}}>
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <img
                  alt="Mobile Logo"
                  src={logo}
                  style={{ width: "255px", height: "auto" }}
                />
              </Link>

              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
              
            </div>
            <div className="mt-[2.2rem] space-y-">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  className="block text-base font-[14px] font-medium text-gray-900 p-2 rounded-lg hover:text-[#FE0467]"
                  onClick={() => setMobileMenuOpen(false)}
                  style={{fontSize: '14px', fontWeight: '600'}}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>
      <HeroSection />
    </>
  );
};

export default Navbar;
